var map = {
	"./eq.png": 114,
	"./kws.png": 115,
	"./nvidia.svg": 116,
	"./pratik.PNG": 117,
	"./pratik.jpeg": 26,
	"./ril.png": 118,
	"./sci-logo.png": 119,
	"./uou.png": 120,
	"./vit_logo.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;